import React, {Component} from 'react';
import PropTypes from "prop-types";
import Timeformat from "../../utils/Timeformat";

class UserAccountContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        requestUserData: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {};

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

    }

    render() {

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const userValidUntil = this.props.baseData.userData.valid_until;
        const validUntil = Timeformat.fromUnix(userValidUntil).getFormatedDate(this.timeFormats.datetime, timezone);

        return (
            <div className="formSettings">
                <nav>
                    <h1>{this.translate('yourAccount')}</h1>
                </nav>

                <div className="formRow">
                    <table>
                        <tbody>
                            <tr>
                                <td className="text-left labelSpan">{this.translate('validUntil')}</td>

                                <td className="text-left">
                                    <input name="validUntil"
                                           type="text"
                                           value={validUntil}
                                           disabled={true}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );

    }

}

export default UserAccountContainer;
